import React from 'react'
import { About,Footer,Header,Portfolio,Project,Resume } from './container/index'
import { Navbar } from './components/index'
import './App.scss'
import ScrollBar from 'react-smooth-scrollbar';

const App = () => {
  return (
    <div className='app'>
        <Navbar/>
        <Header/>
        <About />
        <Resume/>
        <Portfolio/>
        <Project/>
        <Footer/>

    </div>
  )
}

export default App